<template>
    <div class="channel-page">
        <h1 class="channel-name" v-if="!!channel">{{ channel_name }}</h1>
        <channel
            :channel="channel_id"
            :key="channel_id"
        />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Channel } from '../components'
export default {
    components: {
        Channel,
    },
    computed: {
        ...mapGetters([
            'slack_channels',
            'slack_is_signed_in',
        ]),
        channel() {
            return (this.slack_channels || []).find(ch => ch.id === this.channel_id)
        },
        channel_id() {
            return this.$route.params.id
        },
        channel_name() {
            const ch = this.channel
            return ch && (!ch.is_im && `# ${ch.name}` || ch.user_info.real_name) || ''
        },
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
    },
    watch: {
    },
}
</script>
<style>
.channel-page .channel-name {
  font-size: 18px;
  padding: 11px; }

</style>